import API from '../api-service';
import axios from 'axios';

const baseUri = 'authentication';
const path = process.env.VUE_APP_PLAYAPP_URL + '/' + process.env.VUE_APP_PLAYAPP_URL_STAGE;

export default {
  getAuthentications() {
    return API.get(baseUri);
  },
  postAuthentication(body, syncguid) {
    return API.post(`${baseUri}/${syncguid}`, body);
  },
  patchAuthentication(body, syncguid) {
    return API.patch(`${baseUri}/${syncguid}`, body);
  },
  deleteAuthentication(syncguid) {
    return API.delete(`${baseUri}/${syncguid}`);
  },
  testAuthentication(syncguid) {
    const params = {
      syncguid,
      redirect: `${window.location.origin}/auth-success`,
      session: 'preview-session',
    };
    return axios.get(`${path}/authentication/saml2-link`, { params }).then(res => {
      window.open(res.data);
    });
  },
  getAuthenticationMetadata(syncguid) {
    return `${path}/auth/saml2/${syncguid}/metadata`;
  },
};
